module.exports = __webpack_public_path__ + "img/cake.56df1d55.svg";